import type { FaireProductEntity } from "../../entity_types/product";

export const p_durebkmbe0: FaireProductEntity = {
  token: "p_durebkmbe0",
  type: "product",
  name: "Teardrop Necklace - Bestseller",
  brandToken: "b_p4ik7ym3",
  brandName: "Britta Ambauen Jewelry",
  imageUrl: "https://cdn.faire.com/res/hszgttpjt/image/upload/6ffd5edc346fc989a43bfbe63d29c56c593ef0bb8fe728224c26b8d81c659cdd/1564938480.jpg",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/11da41cf1a3126d7369acf8c2ef21fa68ba29d5d8cda62faefe5d559aa72e4ee/1564938559.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/8606588639caffc79ef9c7da469ee7ca209d5b067f09341ddce2d82a98ada043/1564938803.jpg",
    "https://cdn.faire.com/fastly/77cd1275d78d7a11755179d7856403edf672020f983e7e69c860a03593fc4807.jpeg",
    "https://cdn.faire.com/fastly/b83937f09c05cde2944399a624ee5c7cc4b65ff36053ed73e05f58244d48a344.jpeg",
    "https://cdn.faire.com/fastly/0be90b0d3c4ca102f023889c64e63329315e1c4151df0b68dfb60a3217977159.jpeg",
    "https://cdn.faire.com/fastly/d4ca4adca1afb894892ce5aa371d29cf0b885dadee91778cdcbcdade7b51d10a.jpeg",
    "https://cdn.faire.com/fastly/09f9e5499c7c06d96b224078891fbdab84f87b7190eb3a3b31a6ad1d224bd614.jpeg",
    "https://cdn.faire.com/fastly/9f658aef4cf2a9e9840cd8840edf54de098b345f7f7e37f0e34992ccded19cad.jpeg",
    "https://cdn.faire.com/fastly/17d8d5b22c405b50473e5fd80ae5bb70130a0bcc55fc266ab948f09d145ca43f.jpeg",
    "https://cdn.faire.com/fastly/1008a4f535657741305b4acbfefdf8377db9c447fa7df6aa420f06793b02ae9f.jpeg",
    "https://cdn.faire.com/fastly/32593e667d662aff110684a67ef55c61ac10cd6ceed8f3c408cc1ae5d17f7dfc.jpeg",
    "https://cdn.faire.com/fastly/f16bd849fa034568e90bccf290abc05ecba03bafb77e0d5ba2f437766000cae8.jpeg",
    "https://cdn.faire.com/fastly/339196bbdb75eb3c03ddb92c77d9798a3307e784cc580f30db25f127ab337554.jpeg",
    "https://cdn.faire.com/fastly/77160a525727e958cea0a53b5f88f2b1058c11437b61429daabfac4a3526d460.jpeg",
    "https://cdn.faire.com/fastly/abbb563d3196a97c2599964ef849f7652fe0ad099c8882eca0844eaf1f942bd2.jpeg",
    "https://cdn.faire.com/fastly/8e0e295c0c3728203b2072f8f9de496e28bcb70adea59bb504180b808ee72b09.jpeg",
    "https://cdn.faire.com/fastly/4e7660ebaecf84fa8daa70163ecd3ddab0006f217e3befee9eb0879e23822b04.jpeg",
    "https://cdn.faire.com/fastly/6e3c21ba7e71180cf67f34e5db540956bcab0d34e904693bbe5cc41d0d06b676.jpeg",
    "https://cdn.faire.com/fastly/bc1b33888f4c6fb82a6a1c2c3bce3f02c7bb9f0c1033f2b0049564e8bc1dcf7e.jpeg",
    "https://cdn.faire.com/fastly/6280c503f768a17175ecb66f17c3eb3397262b664f8909b7219abd057d411d21.jpeg",
    "https://cdn.faire.com/fastly/c3b3b1289f40fb1ed992a7287b45aec54235b189de23257b6a199368f868baa3.jpeg",
    "https://cdn.faire.com/fastly/30a71078bf0d6b7adb0506178debb26f452520b1e62619c3c4d69f184231fbe9.jpeg",
    "https://cdn.faire.com/fastly/1b1f1f735479864b0a6327cc0eff2775a3ed1b18462ebe74b1b09fc2c49dc518.jpeg",
    "https://cdn.faire.com/fastly/e420d33da7bee74a7484d2ff5c9afe689fd8edb77751e572b404c1b1da67c586.jpeg",
    "https://cdn.faire.com/fastly/654eee24df683142b0dfd58028e00934d751fa79c4d44c73c76af02785c48469.jpeg",
    "https://cdn.faire.com/fastly/8f15cf0113119513c22c4a3c038d1534697e6f995cc5f4b5988dfbd5675c5ca3.jpeg",
    "https://cdn.faire.com/fastly/8034509dd02fe5e753743d1268449edddc91b439854fa2d4f8bf21b6c5146c2a.jpeg"
  ],
  priceDollars: 17,
  description: "Our bestselling, instant classic: the Teardrop Necklace. Beautiful handpicked gemstones finished on natural silk cord with a sterling clasp. 16.5\" length, versatile enough to wear through all of life's adventures.\n\nDisplay board available as an add-on item, or ask us about receiving a free display with minimum opening order of $500 in teardrop necklaces. Perfect for placing at the cash-wrap, these delicate, meaningful necklaces come carded and ready for gifting. They sell themselves!",
  tags: [],
  msrpDollars: 34,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-07T18:31:38.526Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
